import AppSystemModelBase from '../_generated/modelBases/app-system-model-base';

export default class AppSystemModel extends AppSystemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
